import React from 'react'

/** Main fluid layout used by the app.  */
const MainFluidLayout: React.FC<React.HtmlHTMLAttributes<HTMLDivElement>> = ({
  children,
  ...other
}) => {
  return (
    <div className="w-full" {...other}>
      <div className="p-6 lg:px-8">{children}</div>
    </div>
  )
}

export default MainFluidLayout
